import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=0f9959a3&scoped=true&"
import script from "./Stars.vue?vue&type=script&lang=js&"
export * from "./Stars.vue?vue&type=script&lang=js&"
import style0 from "./Stars.vue?vue&type=style&index=0&id=0f9959a3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9959a3",
  null
  
)

export default component.exports